export default {
  pt:{
    UMA_LANG_SASUMA_BENVINDO: "Bem-vindo aos Serviços de Ação<br>Social da Universidade da Madeira",
    UMA_LANG_SASUMA_HOMEMENU_BOLSAS: "Bolsas",
    UMA_LANG_SASUMA_HOMEMENU_ALIMENTACAO: "Alimentação",
    UMA_LANG_SASUMA_HOMEMENU_ALOJAMENTO: "Alojamento",
    UMA_LANG_SASUMA_HOMEMENU_AVISOS:"Avisos",
    UMA_LANG_SASUMA_HOMEMENU_NOTICIAS:"Notícias",
    UMA_LANG_SASUMA_HOMEMENU_DOCUMENTACAO:"Documentação",
    UMA_LANG_SASUMA_HOMEINTRO: "A ação social da Universidade da Madeira (UMa), é desenvolvida através dos Serviços de Acção Social da Universidade da Madeira (SASUMa).",
    UMA_LANG_SASUMA_HOMEINTRO2: `Os SASUMa tem por missão proporcionar aos estudantes da UMa, serviços e apoios de qualidade, justos, solidários, transparentes e equilibrados, com vista às melhores condições de integração e sucesso escolar, garantindo a igualdade de oportunidades no acesso e frequência no Ensino Superior.
    Tem como visão ser um Serviço com padrões de qualidade com reconhecimento europeu, inovando e fazendo a diferença junto dos estudantes mais carenciados.
    São valores dos SASUMa a equidade, justiça social, transparência, qualidade, cidadania, equilíbrio ambiental, inovação, cooperação e o contínuo envolvimento e 
    motivação, de colaboradores e equipas de trabalho.`,
    UMA_LANG_SASUMA_SERVICOSSAS: "Serviços dos SASUMa",
    servicos: {
      UMA_LANG_SASUMA_HOME_SERVICOS_ALOJAMENTO_DESCRICAO: "A Residência Universitária propociona<br>alojamento de cariz social",
      UMA_LANG_SASUMA_HOME_SERVICOS_ALIMENTACAO_DESCRICAO: "Restaurantes e Refeições ao<br>dispôr da comunidade académica",
      UMA_LANG_SASUMA_HOME_SERVICOS_BOLSA_DESCRICAO: "Apoios para frequência de cursos<br>e estágios profissional"
    },
    UMA_LANG_SASUMA_AVISOSECOMUNICADOS: "Avisos e Comunicados",
    UMA_LANG_SASUMA_AVISOSECOMUNICADOS_SEMAVISOS: "Sem avisos",
    UMA_LANG_SASUMA_VERMAIS: "Ver Mais",
    UMA_LANG_SASUMA_HOME_BOLSAS: "Bolsas de Estudo",
    UMA_LANG_SASUMA_HOME_EMENTASEMANAL: "Ementa Semanal",
    UMA_LANG_SASUMA_REFEICAO_ALMOCO:"Almoço",
    UMA_LANG_SASUMA_REFEICAO_JANTAR:"Jantar",
    UMA_LANG_SASUMA_REFEICAO_SEM_EMENTAS:"Sem ementas disponíveis para o dia e refeição selecionada",
    refeicoes: {
      Sopa: "Sopa",
      Carne: "Prato de Carne",
      Peixe: "Prato de Peixe",
      Vegetariano: "Vegetariano",
      Acompanhamento: "Acompanhamento",
      Sobremesa: "Sobremesa",
      sandes: "Sandes do dia",
      salada: "Salada do dia"
    },
    UMA_LANG_SASUMA_FAQ: "Perguntas Frequentes",
    UMA_LANG_BIBLIOTECA_EQUIPA: "Equipa",
    UMA_LANG_SASUMA_HOME_FOOTER_CONTACTOSEHORARIOS: "Contactos e Horário",
    UMA_LANG_SASUMA_HOME_FOOTER_PLANOCONTIGENCIA: "Plano de Contingência",
    UMA_LANG_SASUMA_HOME_FOOTER_DOCUMENTACAO: "Documentação",
    UMA_LANG_SASUMA_HOME_FOOTER_LIGACOES: "Ligações",
    UMA_LANG_SARESPONSAVELWORD:"Responsável",
    UMA_LANG_BIBLIOTECA_LOCALIZACAO: "Localização",
    UMA_LANG_SASUMA_HORARIO: "Contactos e Horário",
    breadcrumb:{
      sobre: "Sobre",
      apoio: "Serviços Apoio Estudante",
      sas: "SASUMa",
      equipa: "Equipa",
      bolsas: "Bolsas de Estudo",
      alimentacao: "Alimentação",
      alojamento: "Alojamento",
      avisos: "Avisos e Comunicados",
      noticias: "Notícias",
      documentacao: "Documentação"
    },
    UMA_LANG_SASUMA_BOLSAS_TITULO: "Bolsas de Estudo",
    UMA_LANG_SASUMA_BOLSAS_TEXTO: `Os SASUMa atribuem bolsas de estudo, bem como auxílios de emergência a alunos do 1o e 2o
    ciclos, tornando assim possível a realização e continuação dos estudos a estudantes que apresentem uma situação económica carenciada.<br>
    
    Os Serviços de Ação Social da Universidade da Madeira, estão integrados na Plataforma Informática da Direcção Geral de Ensino Superior (DGES), por intermédio do Protocolo de colaboração entre ambas as partes, sendo que todos os pagamentos de bolsas de estudo atribuídas são pagas diretamente pela DGES.<br>
    
    Na página pessoal do aluno, pode ser consultado os pagamentos realizados, bem como o número de meses, montante e o NIB para o qual é realizada a transferência.<br>
    
    Para qualquer assunto relacionado com as Bolsas de Estudo deverá contatar o seguinte email: <a href="mailto:bolsas.estudo{'@'}sas.uma.pt">bolsas.estudo{'@'}sas.uma.pt</a><br>
    As Bolsas de Estudo são cofinanciadas pelo FSE, no âmbito do POISE e pelo estado Português.<br>`,
    UMA_LANG_SASUMA_BOLSAS_DETALHE_DESCARREGARPROTOCOLO: "Descarregar protocolo de cooperação",
    UMA_LANG_SASUMA_ALIMENTACAO_TEXTO:`Os Serviços de Acção Social da Universidade da Madeira dispõem quatro Snack-bares,
                    um Restaurante Académico e uma Cantina, dos quais todos os alunos, pessoal docente e
                    não docente têm acesso, bem como outros utente autorizados.<br>
                    Snack-Bar dos Alunos, Snack-Bar dos Funcionários não docentes, docentes e
                    investigadores; Cantina e Restaurante Académico no Campus Universitário da
                    Penteada.<br>
                    Snack-Bar do Colégio dos Jesuítas situado na Reitoria da Universidade da Madeira.<br>
                    Snack-Bar da Residência Universitária situado na Rua de Santa Maria.<br>
                    Para qualquer assunto relacionado com o Gabinete Alimentar deverá contatar o
                    seguinte e-mail:
                    <b><a>isadora.gomes{'@'}sas.uma.pt</a></b>`,
    UMA_LANG_SASUMA_ALIMENTACAO_DESCARREGARPRECARIO:"Descarregar Preçário em Vigor",
    UMA_LANG_SASUMA_ALIMENTACAO_EMENTASEMANAL: "Ementa Semanal",
    UMA_LANG_SASUMA_ALIMENTACAO_RESTAURANTESEHORARIOS: "Restaurantes e Horários",
    UMA_LANG_SASUMA_ALOJAMENTO_INTRO: `<b>Informações Gerais:</b><br>
    A Residência Nossa Senhora das Vitórias dispõe de 82 Quartos, um Snack-Bar aberto das 08:30 
    às 15:30, Receção aberta 24h, um serviço de venda automática de produtos alimentares, uma
     lavandaria, serviço de fotocopias, estacionamento mediante pagamento e ainda internet em todo o espaço.<br>É importante salientar que as instalações estão preparadas para pessoas com mobilidade reduzida.

    <br>
    <br>


    <b>Comissão de Residentes:</b><br>
    A Comissão de Residentes da Residência Universitária é constituída por um Presidente e dois Vice-presidentes, sendo imperativa a frequência destes alunos na Universidade da Madeira.
    Esta Comissão, tem como objectivo primordial representar e defender os direitos dos residentes perante os Serviços de Acção Social da Universidade da Madeira (SASUMa).<br>
    Poderá consultar mais informações relativas à Comissão de Residentes <b><a target='_blank' href='https://testuma.sharepoint.com/:i:/s/outrasestruturas/sasuma/areaprivada/alojamento/EQDEJq012YBEt1KJqxodncYBirC9Wvd5fTxVI8q5a-3PhA?e=YR4DLM'>aqui</a></b>.<br>

    <br>





    Para qualquer assunto relacionado com a Residência Universitária deverá contatar os seguintes e-mails:<br>
    <b><a>reservas{'@'}sas.uma.pt</a></b>

    <br>`,
    UMA_LANG_SASUMA_ALOJAMENTO_DESCARREGARREGULAMENTO:"Descarregar Regulamento em Vigor",
    UMA_LANG_SASUMA_ALOJAMENTO_DESCARREGARPRECARIOHOTELARIA: "Descarregar Preçário Alojamento para Hotelaria",
    UMA_LANG_SASUMA_ALOJAMENTO_DESCARREGARPRECARIOACADEMIA: "Descarregar Preçário Alojamento para Academia",
    UMA_LANG_SASUMA_ALOJAMENTO_DESCARREGARPRECARIOSERVICOS: "Descarregar Preçário dos Serviços Disponíveis",
    UMA_LANG_SASUMA_CALL1: "A Residência Universitária está inserida no coração da cidade do Funchal",
    UMA_LANG_SASUMA_CALL2: "Casas de banho inidividuais e comuns",
    UMA_LANG_SASUMA_CALL3: "",
    UMA_LANG_SASUMA_CALL4: "A Residência Universitária está inserida no coração da cidade do Funchal",
    UMA_LANG_SASUMA_CALL5: "A Residência Universitária da Madeira dispõe de 3 Salas de Convívio",
    UMA_LANG_SASUMA_CALL6: "",
    UMA_LANG_SASUMA_CALL7: "Lavandaria de uso comum, equioada com máquinas de lavar e secar",
    UMA_LANG_SASUMA_CALL8: "O alojamento é destinado a alunos, alunos em mobilidade, alunos internacionais e investigadores",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM: "Áreas Comuns",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_COZINHA: "Cozinhas",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_LAVANDARIA: "Lavandaria",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_SALAESTUDO: "Sala de Estudo",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_SALACONVIVIO: "Salas de Convívio",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_ESTACIONAMENTO: "Estacionamento",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_COZINHA_TEXTO: "A Residência Universitária da Universidade da Madeira dispõe de 4 cozinhas de uso comum - mobiladas e equipada.",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_LAVANDARIA_TEXTO: "A Residência Universitária da Universidade da Madeira dispõe de uma Lavandaria de uso comum, equipada com máquinas de lavar e secar; a utilização destas máquinas requer a utilização de uma ficha própria para o efeito, que pode ser adquirida por 2,50€.",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_SALAESTUDO_TEXTO: "A Residência Universitária da Universidade da Madeira dispõe de 1 Sala de Estudo mobilada de uso comum.",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_SALACONVIVIO_TEXTO: "A Residência Universitária da Universidade da Madeira dispõe de 3 Salas de Convívio.",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_ESTACIONAMENTO_TEXTO: `A Residência Universitária da Universidade da Madeira dispõe de Estacionamento Automóvel.<br>A utilização deste estacionamento implica o pagamento de uma tarifa diária ou mensal, podendo o preçário pode ser consultado <a target='_blank' 
    href='https://testuma.sharepoint.com/sites/outrasestruturas/sasuma/areaprivada/alojamento/ficheiros/Forms/AllItems.aspx?id=%2Fsites%2Foutrasestruturas%2Fsasuma%2Fareaprivada%2Falojamento%2Fficheiros%2Fprec%CC%A7a%CC%81rio%5Falojamento1%2Ejpg&parent=%2Fsites%2Foutrasestruturas%2Fsasuma%2Fareaprivada%2Falojamento%2Fficheiros&p=true'>aqui</a>.`
    ,UMA_LANG_URH_PESQUISADOCUMENTOS:"Pesquisar Documentos",
    avisoslist:{
      referencia: "Referência",
      descricao: "Descrição",
      data: "Data",
      semdoc: "Não existem Avisos disponíveis",
      listadeavisos: "Lista de Avisos"
    },
    UMA_LANG_SASUMA_AVISOS_VERTODOSOSAVISOS:"Ver todos os avisos",
    UMA_LANG_DATAPUB: "Data de publicação",
    UMA_LANG_MAISRECENTES: "Mais recentes",
    UMA_LANG_MAISACEDIDAS: "Mais acedidas",
    UMA_LANG_TODASNOTICIAS: "VER TODAS AS NOTÍCIAS",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_TODOS: "Todos",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_ALOJAMENTO: "Alojamento",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_BOLSASESTUDO: "Bolsas de Estudo",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_ALIMENTACAO: "Alimentação",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_PRECARIOS: "Preçários",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_LEGISLACAO: "Legislação",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_INSTRUMENTOS: "Instrumentos/Indicadores de Gestão",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_CONTRATACAOPUBLICA: "Contratação Pública e Procedimentos Concursais",
    apesquisar: "A pesquisar",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS: "Destinatários:",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EI: "Estudantes Internacionais",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EUB: "Estudantes UMa - Bolseiro",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EUD: "Estudantes UMa - Deslocado",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EOUTROS: "Outros Estudantes - Autorizados",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EMOBILIDADE: "Estudantes em Programa de Mobilidade na UMa",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_OUTROS: "Outros",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_PRAZOCANDIDATURA: "Prazo de Candidatura",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_DE: "de",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_A: "a",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_SEMPREDISPONIVEL: "Sempre disponível",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_SUBMETERCANDIDATURA: "Submeter Candidatura",
    UMA_LANG_SASUMA_ALOJAMENTO_INFOADISPONIBILIZAR: "Informação a disponibilizar",
    form:{
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_TITULO: "Formulário de Candidatura a Alojamento",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_PROTECAO: `Os dados pessoais submetidos neste formulário são para uso exclusivo dos SASUMa, no âmbito do seu processo de 
      alojamento na residência universitária. Estes dados são privados e nunca serão divulgados nem utilizados para
       outros fins que não os estipulados. Após ter passado o prazo legal necessário para a conservação destes dados, 
       estes poderão ser anonimizados unicamente para efeitos de alguma análise estatística`,
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_OPTIONAL: "Opcional",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_CANCELAR: "Cancelar",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_SUBMETER: "Submeter",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_SUCCESS: "A sua candidatura foi submetida com sucesso."
    },
    UMA_LANG_SASUMA_ALOJAMENTO_FORM_CONCURSO: "Concurso",
    UMA_LANG_SASUMA_ALOJAMENTO_FORM_NOMECOMPLETO: "Nome completo",
    UMA_LANG_SASUMA_ALOJAMENTO_FORM_NUMALUNO: "Número de Aluno",
    UMA_LANG_SASUMA_ALOJAMENTO_FORM_DISTRITO: "Distrito",
    UMA_LANG_SASUMA_ALOJAMENTO_FORM_LOCALIDADE: "Localidade",
    UMA_LANG_SASUMA_ALOJAMENTO_FORM_EALUNO: "Aluno da UMA",
    UMA_LANG_SASUMA_ALOJAMENTO_FORM_TELEMOVEL: "Telemóvel",
    UMA_LANG_SASUMA_ALOJAMENTO_FORM_EMAIL: "Email",
    UMA_LANG_SASUMA_ALOJAMENTO_FORM_DATAENTRADA: "Alojamento - Data de entrada",
    UMA_LANG_SASUMA_ALOJAMENTO_FORM_DATASAIDA: "Alojamento - Data de saída",
    UMA_LANG_SASUMA_ALOJAMENTO_FORM_SIM: "Sim",
    UMA_LANG_SASUMA_ALOJAMENTO_FORM_NAO: "Não",
    formfield:{
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_CONCURSO: "Concurso",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_NOMECOMPLETO: "Nome Completo",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_NUMALUNO: "Número de Aluno",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_DISTRITO: "Distrito",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_LOCALIDADE: "Localidade",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_EALUNO: "Aluno da UMA",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_TELEMOVEL: "Telemóvel",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_EMAIL: "Email",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_DATAENTRADA: "Alojamento - Data de entrada",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_DATASAIDA: "Alojamento - Data de saída",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_SIM: "Sim",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_NAO: "Não"
    }
  },
  en:{
    UMA_LANG_SASUMA_BENVINDO: "Bem-vindo aos Serviços de Ação<br>Social da Universidade da Madeira",
    UMA_LANG_SASUMA_HOMEMENU_BOLSAS: "Bolsas",
    UMA_LANG_SASUMA_HOMEMENU_ALIMENTACAO: "Alimentação",
    UMA_LANG_SASUMA_HOMEMENU_ALOJAMENTO: "Alojamento",
    UMA_LANG_SASUMA_HOMEMENU_AVISOS:"Avisos",
    UMA_LANG_SASUMA_HOMEMENU_NOTICIAS:"Notícias",
    UMA_LANG_SASUMA_HOMEMENU_DOCUMENTACAO:"Documentação",
    UMA_LANG_SASUMA_HOMEINTRO: "A ação social da Universidade da Madeira (UMa), é desenvolvida através dos Serviços de Acção Social da Universidade da Madeira (SASUMa).",
    UMA_LANG_SASUMA_HOMEINTRO2: `Os SASUMa tem por missão proporcionar aos estudantes da UMa, serviços e apoios de qualidade, justos, solidários, transparentes e equilibrados, com vista às melhores condições de integração e sucesso escolar, garantindo a igualdade de oportunidades no acesso e frequência no Ensino Superior.
    Tem como visão ser um Serviço com padrões de qualidade com reconhecimento europeu, inovando e fazendo a diferença junto dos estudantes mais carenciados.
    São valores dos SASUMa a equidade, justiça social, transparência, qualidade, cidadania, equilíbrio ambiental, inovação, cooperação e o contínuo envolvimento e motivação,
     de colaboradores e equipas de trabalho.`,
    UMA_LANG_SASUMA_SERVICOSSAS: "Serviços dos SASUMa",
    servicos: {
      UMA_LANG_SASUMA_HOME_SERVICOS_ALOJAMENTO_DESCRICAO: "A Residência Universitária propociona<br>alojamento de cariz social",
      UMA_LANG_SASUMA_HOME_SERVICOS_ALIMENTACAO_DESCRICAO: "Restaurantes e Refeições ao<br>dispôr da comunidade académica",
      UMA_LANG_SASUMA_HOME_SERVICOS_BOLSA_DESCRICAO: "Apoios para frequência de cursos<br>e estágios profissional"
    },
    UMA_LANG_SASUMA_AVISOSECOMUNICADOS: "Avisos e Comunicados",
    UMA_LANG_SASUMA_AVISOSECOMUNICADOS_SEMAVISOS: "Sem avisos",
    UMA_LANG_SASUMA_VERMAIS: "Ver Mais",
    UMA_LANG_SASUMA_HOME_BOLSAS: "Bolsas de Estudo",
    UMA_LANG_SASUMA_HOME_EMENTASEMANAL: "Ementa Semanal",
    UMA_LANG_SASUMA_REFEICAO_ALMOCO:"Almoço",
    UMA_LANG_SASUMA_REFEICAO_JANTAR:"Jantar",
    UMA_LANG_SASUMA_REFEICAO_SEM_EMENTAS:"Sem ementas disponíveis para o dia e refeição selecionada",
    refeicoes: {
      Sopa: "Sopa",
      Carne: "Prato de Carne",
      Peixe: "Prato de Peixe",
      Vegetariano: "Vegetariano",
      Acompanhamento: "Acompanhamento",
      Sobremesa: "Sobremesa",
      sandes: "Sandes do dia",
      salada: "Salada do dia"
    },
    UMA_LANG_SASUMA_FAQ: "Perguntas Frequentes",
    UMA_LANG_BIBLIOTECA_EQUIPA: "Equipa",
    UMA_LANG_SASUMA_HOME_FOOTER_CONTACTOSEHORARIOS: "Contactos e Horário",
    UMA_LANG_SASUMA_HOME_FOOTER_PLANOCONTIGENCIA: "Plano de Contingência",
    UMA_LANG_SASUMA_HOME_FOOTER_DOCUMENTACAO: "Documentação",
    UMA_LANG_SASUMA_HOME_FOOTER_LIGACOES: "Ligações",
    UMA_LANG_SARESPONSAVELWORD: "Responsible Person",
    UMA_LANG_BIBLIOTECA_LOCALIZACAO: "Localização",
    UMA_LANG_SASUMA_HORARIO: "Contactos e Horário",
    breadcrumb:{
      sobre: "Sobre",
      apoio: "Serviços Apoio Estudante",
      sas: "SASUMa",
      equipa: "Equipa",
      bolsas: "Bolsas de Estudo",
      alimentacao: "Alimentação",
      alojamento: "Alojamento",
      avisos: "Avisos e Comunicados",
      noticias: "Notícias",
      documentacao: "Documentação"
    },
    UMA_LANG_SASUMA_BOLSAS_TITULO: "Bolsas de Estudo",
    UMA_LANG_SASUMA_BOLSAS_TEXTO: `Os SASUMa atribuem bolsas de estudo, bem como auxílios de emergência a alunos do 1o e 2o
    ciclos, tornando assim possível a realização e continuação dos estudos a estudantes que apresentem uma situação económica carenciada.<br>
    
    Os Serviços de Ação Social da Universidade da Madeira, estão integrados na Plataforma Informática da Direcção Geral de Ensino Superior (DGES), por intermédio do Protocolo de colaboração entre ambas as partes, sendo que todos os pagamentos de bolsas de estudo atribuídas são pagas diretamente pela DGES.<br>
    
    Na página pessoal do aluno, pode ser consultado os pagamentos realizados, bem como o número de meses, montante e o NIB para o qual é realizada a transferência.<br>
    
    Para qualquer assunto relacionado com as Bolsas de Estudo deverá contatar o seguinte email: <a href="mailto:bolsas.estudo{'@'}sas.uma.pt">bolsas.estudo{'@'}sas.uma.pt</a><br>
    As Bolsas de Estudo são cofinanciadas pelo FSE, no âmbito do POISE e pelo estado Português.<br>`,
    UMA_LANG_SASUMA_BOLSAS_DETALHE_DESCARREGARPROTOCOLO: "Descarregar protocolo de cooperação",
    UMA_LANG_SASUMA_ALIMENTACAO_TEXTO:`Os Serviços de Acção Social da Universidade da Madeira dispõem quatro Snack-bares,
    um Restaurante Académico e uma Cantina, dos quais todos os alunos, pessoal docente e
    não docente têm acesso, bem como outros utente autorizados.<br>
    Snack-Bar dos Alunos, Snack-Bar dos Funcionários não docentes, docentes e
    investigadores; Cantina e Restaurante Académico no Campus Universitário da
    Penteada.<br>
    Snack-Bar do Colégio dos Jesuítas situado na Reitoria da Universidade da Madeira.<br>
    Snack-Bar da Residência Universitária situado na Rua de Santa Maria.<br>
    Para qualquer assunto relacionado com o Gabinete Alimentar deverá contatar o
    seguinte e-mail:
    <b><a>isadora.gomes{'@'}sas.uma.pt</a></b>`,
    UMA_LANG_SASUMA_ALIMENTACAO_DESCARREGARPRECARIO:"Descarregar Preçário em Vigor",
    UMA_LANG_SASUMA_ALIMENTACAO_EMENTASEMANAL: "Ementa Semanal",
    UMA_LANG_SASUMA_ALIMENTACAO_RESTAURANTESEHORARIOS: "Restaurantes e Horários",
    UMA_LANG_SASUMA_ALOJAMENTO_INTRO: `<b>Informações Gerais:</b><br>
    A Residência Nossa Senhora das Vitórias dispõe de 82 Quartos, um Snack-Bar aberto das 08:30 
    às 15:30, Receção aberta 24h, um serviço de venda automática de produtos alimentares, uma
     lavandaria, serviço de fotocopias, estacionamento mediante pagamento e ainda internet em todo o espaço.<br>É importante salientar que as instalações estão preparadas para pessoas com mobilidade reduzida.

    <br>
    <br>


    <b>Comissão de Residentes:</b><br>
    A Comissão de Residentes da Residência Universitária é constituída por um Presidente e dois Vice-presidentes, sendo imperativa a frequência destes alunos na Universidade da Madeira.
    Esta Comissão, tem como objectivo primordial representar e defender os direitos dos residentes perante os Serviços de Acção Social da Universidade da Madeira (SASUMa).<br>
    Poderá consultar mais informações relativas à Comissão de Residentes <b><a target='_blank' href='https://testuma.sharepoint.com/:i:/s/outrasestruturas/sasuma/areaprivada/alojamento/EQDEJq012YBEt1KJqxodncYBirC9Wvd5fTxVI8q5a-3PhA?e=YR4DLM'>aqui</a></b>.<br>

    <br>





    Para qualquer assunto relacionado com a Residência Universitária deverá contatar os seguintes e-mails:<br>
    <b><a>reservas{'@'}sas.uma.pt</a></b>

    <br>`,
    UMA_LANG_SASUMA_ALOJAMENTO_DESCARREGARREGULAMENTO:"Descarregar Regulamento em Vigor",
    UMA_LANG_SASUMA_ALOJAMENTO_DESCARREGARPRECARIOHOTELARIA: "Descarregar Preçário Alojamento para Hotelaria",
    UMA_LANG_SASUMA_ALOJAMENTO_DESCARREGARPRECARIOACADEMIA: "Descarregar Preçário Alojamento para Academia",
    UMA_LANG_SASUMA_ALOJAMENTO_DESCARREGARPRECARIOSERVICOS: "Descarregar Preçário dos Serviços Disponíveis",
    UMA_LANG_SASUMA_CALL1: "A Residência Universitária está inserida no coração da cidade do Funchal",
    UMA_LANG_SASUMA_CALL2: "Casas de banho inidividuais e comuns",
    UMA_LANG_SASUMA_CALL3: "",
    UMA_LANG_SASUMA_CALL4: "A Residência Universitária está inserida no coração da cidade do Funchal",
    UMA_LANG_SASUMA_CALL5: "A Residência Universitária da Madeira dispõe de 3 Salas de Convívio",
    UMA_LANG_SASUMA_CALL6: "",
    UMA_LANG_SASUMA_CALL7: "Lavandaria de uso comum, equioada com máquinas de lavar e secar",
    UMA_LANG_SASUMA_CALL8: "O alojamento é destinado a alunos, alunos em mobilidade, alunos internacionais e investigadores",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM: "Áreas Comuns",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_COZINHA: "Cozinhas",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_LAVANDARIA: "Lavandaria",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_SALAESTUDO: "Sala de Estudo",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_SALACONVIVIO: "Salas de Convívio",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_ESTACIONAMENTO: "Estacionamento",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_COZINHA_TEXTO: "A Residência Universitária da Universidade da Madeira dispõe de 4 cozinhas de uso comum - mobiladas e equipada.",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_LAVANDARIA_TEXTO: "A Residência Universitária da Universidade da Madeira dispõe de uma Lavandaria de uso comum, equipada com máquinas de lavar e secar; a utilização destas máquinas requer a utilização de uma ficha própria para o efeito, que pode ser adquirida por 2,50€.",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_SALAESTUDO_TEXTO: "A Residência Universitária da Universidade da Madeira dispõe de 1 Sala de Estudo mobilada de uso comum.",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_SALACONVIVIO_TEXTO: "A Residência Universitária da Universidade da Madeira dispõe de 3 Salas de Convívio.",
    UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_ESTACIONAMENTO_TEXTO: `A Residência Universitária da Universidade da Madeira dispõe de Estacionamento Automóvel.<br>A utilização deste estacionamento implica o pagamento de uma tarifa diária ou mensal, podendo o preçário pode ser consultado <a target='_blank' 
    href='https://testuma.sharepoint.com/sites/outrasestruturas/sasuma/areaprivada/alojamento/ficheiros/Forms/AllItems.aspx?id=%2Fsites%2Foutrasestruturas%2Fsasuma%2Fareaprivada%2Falojamento%2Fficheiros%2Fprec%CC%A7a%CC%81rio%5Falojamento1%2Ejpg&parent=%2Fsites%2Foutrasestruturas%2Fsasuma%2Fareaprivada%2Falojamento%2Fficheiros&p=true'>aqui</a>.`
    ,UMA_LANG_URH_PESQUISADOCUMENTOS:"Pesquisar Documentos",
    avisoslist:{
      referencia: "Referência",
      descricao: "Descrição",
      data: "Data",
      semdoc: "Não existem Avisos disponíveis",
      listadeavisos: "Lista de Avisos"
    },
    UMA_LANG_SASUMA_AVISOS_VERTODOSOSAVISOS:"Ver todos os avisos",
    UMA_LANG_DATAPUB: "Publication Date",
    UMA_LANG_MAISRECENTES: "Latest News",
    UMA_LANG_MAISACEDIDAS: "Most Popular",
    UMA_LANG_TODASNOTICIAS: "VIEW ALL NEWS",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_TODOS: "All Documents",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_ALOJAMENTO: "Alojamento",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_BOLSASESTUDO: "Bolsas de Estudo",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_ALIMENTACAO: "Alimentação",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_PRECARIOS: "Preçários",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_LEGISLACAO: "Legislação",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_INSTRUMENTOS: "Instrumentos/Indicadores de Gestão",
    UMA_LANG_SASUMA_DOCUMENTOS_TIPO_CONTRATACAOPUBLICA: "Contratação Pública e Procedimentos Concursais",
    apesquisar: "A pesquisar",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS: "Destinatários:",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EI: "Estudantes Internacionais",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EUB: "Estudantes UMa - Bolseiro",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EUD: "Estudantes UMa - Deslocado",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EOUTROS: "Outros Estudantes - Autorizados",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_EMOBILIDADE: "Estudantes em Programa de Mobilidade na UMa",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_OUTROS: "Outros",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_PRAZOCANDIDATURA: "Prazo de Candidatura",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_DE: "from",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_A: "to",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_SEMPREDISPONIVEL: "Sempre disponível",
    UMA_LANG_SASUMA_ALOJAMENTO_DESTINATARIOS_SUBMETERCANDIDATURA: "Submeter Candidatura",
    UMA_LANG_SASUMA_ALOJAMENTO_INFOADISPONIBILIZAR: "Informação a disponibilizar",
    form:{
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_TITULO: "Formulário de Candidatura a Alojamento",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_PROTECAO: `Os dados pessoais submetidos neste formulário são para uso exclusivo dos SASUMa, no âmbito do seu processo de 
      alojamento na residência universitária. Estes dados são privados e nunca serão divulgados nem utilizados para
       outros fins que não os estipulados. Após ter passado o prazo legal necessário para a conservação destes dados, 
       estes poderão ser anonimizados unicamente para efeitos de alguma análise estatística`,
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_OPTIONAL: "Optional",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_CANCELAR: "Cancel",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_SUBMETER: "Submit",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_SUCCESS: "A sua candidatura foi submetida com sucesso."
    },
    formfield:{
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_CONCURSO: "Concurso",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_NOMECOMPLETO: "Full Name",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_NUMALUNO: "Número de Aluno",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_DISTRITO: "Distrito",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_LOCALIDADE: "Localidade",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_EALUNO: "Aluno da UMA",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_TELEMOVEL: "Telemóvel",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_EMAIL: "Email",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_DATAENTRADA: "Alojamento - Data de entrada",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_DATASAIDA: "Alojamento - Data de saída",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_SIM: "Yes",
      UMA_LANG_SASUMA_ALOJAMENTO_FORM_NAO: "No"
    }
  }
}